import React from 'react';
import { useTranslation } from 'react-i18next';
import RowResumeText from '../../../../../../components/RowResumeText';
import { EMPTY_VALUES } from '../../../../../../Apis/functions';
import ResumeInfoCard from '../../../../../../components/ResumeInfoCard';
import { DocumentationFolderIcon, FolderPerson } from '../../../../../../components/buttons/IconButtons';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const SummaryOtherDetailsCard = ({ extraData, headersList }) => {
    const { t } = useTranslation();
    return (
        <ResumeInfoCard
            title={t('other_details')}
            titleIcon={<DocumentationFolderIcon width={24} height={24} />}
            icon={<FolderPerson className='btn-icon-svg-24px' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='grid-container-resume-data mb-2'>
                    {Array.from({ length: 15 }, (_, index) => (
                        <RowResumeText
                            key={index}
                            className='d-flex flex-column p-2 background-shades-50 border-radius-8px'
                            title={headersList[`header${index + 1}`] || `header_${index + 1}`}
                            value={extraData[`field${index + 1}`] || EMPTY_VALUES.DEFAULT}
                        />
                    ))}
                </div>
            }
        />
    );
};

export default SummaryOtherDetailsCard;
